export type ConversationMessageIdentity={id:string;occurred_at:string};
export type ConversationOrder='newest'|'oldest';

function timestamp(value:string){
  const parsed=Date.parse(value);
  return Number.isNaN(parsed)?Number.NEGATIVE_INFINITY:parsed;
}

export function compareConversationMessages(left:ConversationMessageIdentity,right:ConversationMessageIdentity){
  const timeDifference=timestamp(left.occurred_at)-timestamp(right.occurred_at);
  return timeDifference||left.id.localeCompare(right.id,'en-GB');
}

export function orderConversationMessages<T extends ConversationMessageIdentity>(messages:readonly T[],order:ConversationOrder='newest'){
  const chronological=[...messages].sort(compareConversationMessages);
  return order==='newest'?chronological.reverse():chronological;
}

export function latestConversationMessage<T extends ConversationMessageIdentity>(messages:readonly T[]){
  return orderConversationMessages(messages,'oldest').at(-1);
}
